// Its own module so a page can start this fetch without importing the drawer.
export const loadCartDrawerContent = () => import('./CartDrawerContent');
